module.exports = __webpack_public_path__ + "img/hzfp47.58215115.png";